import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const VisionSection = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-[var(--color-background)] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 md:w-96 md:h-96 lg:w-[32rem] lg:h-[32rem] rounded-full bg-[var(--color-primary)]/5 blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-64 h-64 md:w-96 md:h-96 lg:w-[32rem] lg:h-[32rem] rounded-full bg-[var(--color-accent)]/5 blur-3xl translate-x-1/2 translate-y-1/2" />

      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        {/* Circular floating layout */}
        <div className="relative flex items-center justify-center min-h-[500px] md:min-h-[600px]">
          {/* Center icon circle */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-accent)] flex items-center justify-center shadow-2xl animate-pulse">
            <Icon name="Sparkles" size={40} color="white" className="md:w-12 md:h-12" />
          </div>

          {/* Floating heading - top */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 text-center">
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-accent)] bg-clip-text text-transparent">
              كُن حلقةً في السلسلة
            </h3>
          </div>

          {/* Floating description - middle */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 translate-y-12 md:translate-y-16 text-center max-w-2xl px-4">
            <p className="text-lg md:text-xl lg:text-2xl text-[var(--color-text-secondary)] leading-relaxed font-body">
              انضم إلى مجتمع دوائر وساهم في صناعة مستقبل الثقافة العربية
            </p>
          </div>

          {/* Floating buttons - bottom */}
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 w-full px-4">
            <Button
              variant="secondary"
              size="lg"
              onClick={() => {
                if (isAuthenticated) {
                  navigate('/creator-studio');
                } else {
                  navigate('/signup', { state: { directToForm: true } });
                }
              }}
              className="w-full sm:w-auto bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-accent)] text-white hover:opacity-90 shadow-lg rounded-full"
            >
              اترك أثرًا
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/homepage')}
              iconName="BookOpen"
              iconPosition="right"
              className="w-full sm:w-auto border-2 border-[var(--color-primary)] text-[var(--color-primary)] hover:bg-[var(--color-primary)]/10 rounded-full gap-3"
            >
              استكشف المحتوى
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;